import { render, staticRenderFns } from "./PaywallDropdown.vue?vue&type=template&id=77e38fba&scoped=true"
import script from "./PaywallDropdown.vue?vue&type=script&lang=js"
export * from "./PaywallDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e38fba",
  null
  
)

export default component.exports